import { dataUsuarioVacio } from "../../constants";
import {
  LIMPIAR_LOGIN,
  LOGIN_HAS_ERRORED,
  LOGIN_IS_LOADING,
  LOGOUT_SUSCRIPTOR,
  SET_COUNT_CARRITO,
  SET_DATA_USUARIO,
  SET_DATA_USUARIO_SUSCRIPTOR
} from "../actions/aLogin";

export function countCarrito(state = "", action) {
  switch (action.type) {
    case SET_COUNT_CARRITO:
      return action.countCarrito;
    default:
      return state;
  }
}

export const datosUsuarios = (
  state = {
    loginIsLoading: false,
    loginHasError: false,
    dataUsuario: dataUsuarioVacio,
  },
  action
) => {
  switch (action.type) {
    case LOGIN_HAS_ERRORED:
      return {
        ...state,
        loginIsLoading: false,
        loginHasError: true,
      };
    case LOGIN_IS_LOADING:
      return {
        ...state,
        loginIsLoading: true,
        loginHasError: false,
      };
    case SET_DATA_USUARIO:
      return {
        ...state,
        loginIsLoading: false,
        registroIsLoading: false,
        dataUsuario: { ...state.dataUsuario, ...action.payload },
      };
    case SET_DATA_USUARIO_SUSCRIPTOR:
      return {
        ...state,
        loginIsLoading: false,
        registroIsLoading: false,
        dataUsuario: { ...action.payload },
      };
    case LIMPIAR_LOGIN:
      return {
        ...state,
        loginIsLoading: false,
        loginHasError: false,
        dataUsuario: { ...state.dataUsuario, ...dataUsuarioVacio },
      };
    case LOGOUT_SUSCRIPTOR:
      return {
        ...state,
        loginIsLoading: false,
        loginHasError: false,
        dataUsuario: { ...dataUsuarioVacio },
      };
    default:
      return { ...state };
  }
};

export default datosUsuarios;
